/**
 * Selecciona el contenido correcto de un objeto de base de datos basado en el idioma actual.
 * @param {Object} data - El objeto que viene de la DB (ej: banner, footerBlock)
 * @param {string} field - El nombre base del campo (ej: 'title', 'content')
 * @param {string} locale - El código de idioma actual de la app (ej: 'en-US', 'fr', 'es').
 * @returns {string} El texto traducido o el default (español) si no existe traducción.
 */
export default function getLocalizedContent(data, field, locale) {
  if (!data) return '';

  // 1. Obtener código de 2 letras (ej: 'en-US' -> 'en')
  // Si no hay locale, asumimos 'es'
  const code = locale ? locale.substring(0, 2).toLowerCase() : 'es';

  // 2. Determinar nombre del campo
  // Español usa el campo base (ej: 'title')
  // Otros idiomas usan sufijo (ej: 'title_en')
  let targetField = field;
  if (code !== 'es') {
    targetField = `${field}_${code}`;
  }

  // 3. Retornar con Fallback
  // Prioridad: Traducción > Original (Español) > String vacío
  return data[targetField] || data[field] || '';
}
